// extracted by mini-css-extract-plugin
export default {"imgContainer":"news_imgContainer__gXB5P","imgContainer-blur":"news_imgContainer-blur__uuT80"};